import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingErrorComponent } from './loading-error.component';
import { LayoutColumnModule } from '../../directives/layout-column/layout-column.module';
import { LayoutCenterModule } from '../../directives/layout-center/layout-center.module';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';

@NgModule({
    declarations: [LoadingErrorComponent],
    imports: [
        CommonModule,
        LayoutColumnModule,
        LayoutCenterModule,
        MatIconModule,
        MatCardModule,
    ],
    exports: [LoadingErrorComponent]
})
export class LoadingErrorModule {
}
